import React, { Fragment, useEffect, useState } from 'react'
import { Alert, Col, Form, Row } from 'antd'
import { compose } from 'recompose'
import { get } from 'lodash'
import { strVal } from '../../../modules/Utils'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'

function ExistingBudgetForm(props) {
  const { getFieldDecorator } = props.form
  const { owner } = props
  const contract = get(owner, 'contract._id')
  const [BudgetSelect] = useFetchSelectUrl(
    {
      name: 'budgets',
      url: `budgets/?select=*&contract=${contract}&status=Approved`,
      cache: false,
    },
    [contract],
  )

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    },
  }
  const formItemLayoutWithoutLabel = {
    wrapperCol: {
      xs: { span: 24 },
      sm: { offset: 5, span: 15 },
    },
  }
  return (
    <Fragment>
      <Row>
        <Form>
          <Form.Item {...formItemLayoutWithoutLabel}>
            <Alert
              type="info"
              closable
              message={`List of All budgets under contract ${strVal(owner, 'contract.code')}`}
              showIcon
            />
          </Form.Item>
          <Col span={24}>
            <Form.Item {...formItemLayout} label={'Existing Budget'}>
              {getFieldDecorator('budget._id', {
                rules: [{ required: true, message: "Existing Budget can't be empty" }],
              })(<BudgetSelect keyAtr={'_id'} valueAtr={'title'} />)}
            </Form.Item>
          </Col>
        </Form>
      </Row>
    </Fragment>
  )
}

ExistingBudgetForm.propTypes = {}
ExistingBudgetForm.defaultProps = {
  budget: {},
}

export default compose(Form.create())(ExistingBudgetForm)
